{
  "LOGIN_COLMEC_B2B": "Welcome to Colmec B2B. Log in with your user.",
  "COLMEC_CAMPAIGN": "Black Friday",
  "EXPRESS_DELIVERY_NOT_AVAILABLE_SPIKES_SIPING_ASSEMBLY": "Express delivery not available in combination with spikes, siping or assembly",
  "SELECT_ACTION": "Select action",
  "VALIDATION": "Validation",
  "TRY_AGAIN": "Try again",
  "RECYCLING_FEES_WILL_BE_ADDED": "Recycling fees will be added",
  "ITEMS_ADDED_AS_MANDATORY_EXTRAS_TO_ABOVE_CART": "The items below has been automatically added",
  "CART_CONTAINS_AUTO_ADDED_PRODUCTS": "Cart contains auto added products",
  "OH_SALESTYPE": "Salestype",
  "PRODUCTS_NOT_IN_CAMPAIGN": "Products not in campaign",
  "COLMEC_NEW_PRODUCT": "New",
  "USER_AVAILABILITY_OUT_OF_STOCK": "Out of stock. Contact us on 011 - 13 40 37 for information",
  "COLMEC_ADD_DUBBING": "Spikes",
  "COLMEC_NO_PRODUCTS_FOUND_CONTACT_US": "We could not find what you are looking for <br/>Contact us on 011 - 13 40 37 and we will be happy to help you.",
  "YES_EXPRESS_DELIVERY_INCL_COST_INFO": "Yes",
  "EXPRESS_DELIVERY": "Express Shipping - external carrier - next day delivery",
  "AR_VARUGRUPPKOD": "Brand",
  "NO_BRAND_DEFINED": "No brand defined",
  "NO_PATTERN_DEFINED": "No pattern defined",
  "AR_ITEMTYPECD6": "Usage type",
  "NO_USAGE_TYPE_DEFINED": "No usage type defined",
  "AR_Q_MS": "M+S",
  "NO_MS_DEFINED": "No M+S defined",
  "AR_Q_3PMSF": "3PMSF",
  "NO_3PMSF_DEFINED": "No 3PMSF defined",
  "DIMENSION": "Dimension",
  "NO_DIMENSION_DEFINED": "No dimension defined",
  "PRODUCT_RELATED_PRODUCTS": "Related products",
  "NO_PRODUCT_RELATED_PRODUCTS_FOUND": "No related products have been found",
  "PRODUCT_RELATED_ADDONS": "Accessories",
  "NO_PRODUCT_RELATED_ADDONS_FOUND": "No related accessories have been found",
  "SUBASSORTMENTS": "Subassortments",
  "ITEM_NO": "Item No.",
  "NET_PRICE": "Net price",
  "NET_PRICE_INC_FRAME": "Net price inc. frame",
  "AR_ITEMTYPECD1": "Width",
  "AR_ITEMTYPECD2": "Profile",
  "AR_ITEMTYPECD3": "Diameter",
  "AR_ITEMTYPECD4": "Manufacturer",
  "AR_ITEMTYPECD5": "Pattern",
  "AR_Q_POSITION": "Position",
  "AR_Q_MONSTERDJUP": "Tread depth",
  "AR_Q_KLASSID": "Stomklass",
  "NO_STOMKLASS": "No stomklass",
  "LISTPRIS": "LISTPRIS",
  "PRODUCT_DETAIL_PROPERTIES": "Properties",
  "PRODUCT_DETAIL_ADDONS": "Addons",
  "ADDONS": "Addons",
  "PRODUCT_DETAIL_DOCUMENTS": "Documents",
  "SPIKES": "Spikes",
  "THANK_YOU_EMAIL_CONFIRMATION_FROM_CONTEXT_ORIGINAL_INPUT": "An order confimation has been sent to the following addresses",
  "SIPING": "Siping",
  "EU_LABELING": "EU Labeling",
  "ADDITIONAL_COSTS": "Additional costs",
  "EXPRESS_FREIGHT": "Express Freight",
  "BOOLEAN_NO": "No",
  "COLMEC_CHECKOUT_NO_ADDONS": "No options available for selected products",
  "PRICE_EXCLUSIVE_FRAME": "Price excluding frame",
  "ADDITIONAL_DELIVERY_TIME_SIPING_SPIKES": "Delivery time for spikes / siping: 3 days",
  "COLMEC_TOOLTIP_AVAILABIITY_MISSING": "Available stock exceeded",
  "DELIVERY_DATE_REQUIRED": "The Delivery Date is required",
  "PRODUCT_LIST_TOTAL": "Displays {{render}} of {{total}}",
  "COLMEC_DELIVERY_DATE": "Departing from Colmec",
  "COLMEC_SEARCH_PRODUCTS_PLACEHOLDER": "Search: Ex. 315/80 BSG Continental",
  "COLMEC_PLACE_ORDER_TERMS_AND_CONDITIONS": "By submitting the order you agree to our ",
  "COLMEC_PLACE_ORDER_TERMS_AND_CONDITIONS_LINK": "General Terms and Conditions",
  "COLMEC_LOGIN_CONTACT_US": "Missing login information?",
  "COLMEC_LOGIN_CONTACT_US_CONTACTS": "Contact us on webshop@colmec.se and we will help you get started",
  "COLMEC_RIM": "Rim",
  "COLMEC_ASSEMBLY": "Assembly",
  "COLMEC_AUTO_ADDED": "Auto added",
  "COLMEC_ADDON": "Addon",
  "ADD_RIM": "Add Rim",
  "ADD_RIMS": "Add Rims",
  "CLEAR_AND_CLOSE": "Clear and close",
  "ADD_AND_CLOSE": "Add and close",
  "SELECT_ASSEMBLY": "Select Assembly",
  "RIM_REQUIRED": "Need to select one rim and assembly",
  "COLMEC_NO_CAMPAIGNS_FOUND": "We are working on new campaigns in the moment. Please login and check soon again.",
  "NOT_INCLUDE_RETURN": "Our outlet and campaign products do not include return rights.",
  "AR_Q_BULTCIRKEL": "Bolt circle",
  "AR_Q_NAVHAL": "Hub hole",
  "AR_Q_INPRESSNING": "Pressing",
  "AR_Q_BULTHAL": "Bolt hole",
  "AR_Q_ALIVE": "Alive",
  "AR_Q_MAXBELASTNING": "Maximum load",
  "NEW_RETREADED_TIRES_RIMS": "New tires, retreads and rims",
  "USED_TIRES_ARE_MOST": "Used tires are one of the most problematic types of waste today due to the high volume of waste generated,",
  "FOR_THEIR_DURABILITY": "and for their durability",
  "WELCOME_TO_COLMEC_B2B": "Welcome to Colmec B2B",
  "LAST_ORDERS": "Last orders",
  "COLMEC_CIRCLE": "Read more about our new environmental initiative here",
  "FILTER_SEARCH": "Filter your search",
  "MISSING_SOMETHING_SPECIFIC": "Are you missing something specific?",
  "GET_IN_TOUCH": "get in touch with us and we will review",
  "OPORTUNITY_TO_PRODUCE": "the opportunity to produce what you are looking for.",
  "OPEN_HOURS_WEEK": "Opening hours: Mon-Fri",
  "FAQ": "FAQ",
  "SHOW_PRODUCT": "Show Product",
  "EXPLORE_THE_RANGE": "EXPLORE",
  "UNIQUE_TOTAL_CONCEPT": "UNIQUE TOTAL CONCEPT",
  "SAFE_LAZY": "Your safe and profitable",
  "FUNCTIONAL_PARTNER": "functional partner.",
  "PRODUCTS_SERVICES_SERVICE_SUPPORT": "Products, services, service and support",
  "BEST_QUALITY": "with the best quality",
  "TRUST_PERFORMANCE_GREENER_CHOICE": "Trust the performance, make a greener choice",
  "HIGH_QUALITY_RETREADED_TIRES": "with be high quality retreaded tires!",
  "HEADLINE_TRUST_FEEL": "As the headline says, you can trust and feel safe with a retreaded tire made by us!",
  "TECHNOLOGY_DEVELOPMENT_QUALITY": "We are constantly working to be at the forefront when it comes to technology, development and quality.",
  "DISCOVERY_PREMIUM_TIRE": "DISCOVERY BE PREMIUMED TIRE",
  "FULL_TITLE_TEXT": "Scenester beard godard knausgaard keffiyeh, vice banjo coloring book. Sartorial butcher aesthetic meditation pickled polaroid YOLO semiotics austin.",
  "SUBTITLE_TEXT": "Cold-pressed glossier echo park subway tile tumblr, freegan distillery bespoke normcore polaroid. Sratorial celiac literally, freegan synth leggings brooklyn slow-carb messenger bag tbh art party meggings. Adaptogen pour-over portland slow-card, deep v skateboard taiyaki taxidermy.",
  "MANAGE_CUSTOMERS": "Manage customers",
  "MANAGE_ORDERS": "Manage orders",
  "COLMEC_STARTPAGE": "Colmec Startpage",
  "SALES_QUANTITY_PER_YEAR": "Sales quantity per year",
  "SALES_QUANTITY_PER_MONTH": "Sales quantity per month",
  "SALES_QUANTITY_PER_WEEK": "Sales quantity per week",
  "SELECT_PRODUCT": "Select product",
  "SEE_PRICE_PER": "See price per frame",
  "DISC_BRAKES": "Disc brakes",
  "DRUM_BRAKES": "Drum brakes",
  "Levande": "Alive",
  "END_CUSTOMER": "End customer",
  "COLMEC_NO_PRODUCT_CONCEPT": "No products found for this concept",
  "Q_GUNG_EU": "EU Label",
  "LINK": "Link",
  "CREATE_CLAIM": "Create Claim",
  "CLAIM_CREATED_SUCCESS": "Complaint with number {{id}} has been created. A confirmation has been sent to your email.",
  "DETAILS": "DETAILS",
  "CLAIMS": "Claims",
  "ORKK_KUNDREKLAMATIONBESKR": "Type of claim",
  "CLAIMWORKFLOW_CLAIMWORKFLOWDESCR": "Claim feed",
  "Q_ARTSERIENR": "Serial No.",
  "Q_DOTNR": "Dotnr.",
  "EDIT": "Listing",
  "SALJARE": "Seller",
  "FTGNR": "Customer No.",
  "ORDERNR": "Order No.",
  "FAKTNR": "Invoice No.",
  "CLAIMQTY": "Claim Qty",
  "FORETAGKOD": "Company Codde",
  "EVENTNOTE": "Outcome",
  "ARTNR": "Article no",
  "EDIT_CUSTOMER": "Edit customer",
  "UPDATE_CUSTOMER": "Update customer",
  "CUSTOMER_UPDATE_SUCCESS": "Customer updated with success",
  "CUSTOMER_UPDATE_ERROR": "Error when updating customer.",
  "CUSTOMER_UPDATE_FORM_ERROR": "Update customer form contains errors. Revise the fields.",
  "Registered": "New",
  "MARK_AS_REGISTERED": "Mark as New",
  "MARK_AS_NY": "Mark as New",
  "MARK_AS_PÅBÖRJAD": "Mark as Started",
  "MARK_AS_AVSLUTAD": "Mark as Completed",
  "NOTE_ADD_EDIT": "Notes",
  "SEND_QUOTE": "Send quote",
  "Ny": "New",
  "Påbörjad": "Started",
  "Avslutad": "Completed",
  "KOMPLETT_HJUL": "Complete wheels",
  "CLAIMACTIVITYSTATUS_CLAIMACTIVITYSTATUSDESCR": "Activity Status",
  "QUOTE_TO_ORDER": "Convert offer to order",
  "CANCEL_QUOTE": "Cancel offer",
  "QUOTE": "Offer",
  "PARTNER_AGREEMENT": "Partner agreement",
  "PARTNER_AGREEMENTS": "Partner agreements",
  "PARTNER": "Partner",
  "CREATE_AGREEMENT": "Create agreement",
  "PARTNER_AGREEMENT_CREATE": "Create partner agreement",
  "PARTNER_AGREEMENT_EDIT": "Edit partner agreement",
  "SUPPLIER_ID": "Supplier ID",
  "SERVICE_PRICE_LIST_ID": "Service price list ID",
  "PARTNER_ID": "Partner ID",
  "EDIT_PARTNER_AGREEMENT": "Edit partner agreement",
  "VIEW_AGREEMENT": "View agreement",
  "WORK_PERFORMED_DATE": "Work performed date",
  "REG_NR": "Reg. Nr.",
  "REASON_FOR_WORK": "Reason for work",
  "TIRES": "Tires",
  "ADD_TO_WORKING_ORDER": "Add to working order",
  "SEARCH_TIRE": "Search tires based on dimension, brand, pattern or article number",
  "TIRE_POSITION": "Tire position",
  "TIRE_ID": "Tire ID",
  "TIRE_NAME": "Tire name",
  "NO_TIRES_SELECTED_ERROR": "No tires added to working order!",
  "SERVICES": "Services",
  "SEARCH_SERVICE": "Search service",
  "SERVICE_QUANTITY": "Quantity",
  "SERVICE_ID": "Service ID",
  "SERVICE_NAME": "Service name",
  "NO_SERVICES_SELECTED_ERROR": "No services added to working order!",
  "EXTRAS": "Extras",
  "NO_EXTRAS_SELECTED_ERROR": "No extras added to working order!",
  "ARTICLE": "Article",
  "SUBMIT_WORKING_ORDER": "Submit working order",
  "POSITION": "Position",
  "PREVIEW_AGREEMENT": "Preview agreement",
  "DELETE_AGREEMENT": "Delete agreement",
  "DELETE_PARTNER_AGREEMENT_CONFIRM": "Are you sure you want to delete this partner agreement?",
  "TOTAL_QUANTITY": "Total quantity",
  "TOTAL_VALUE": "Total value",
  "SUPPLIER_DELIVERY_NUMBER": "Supplier delivery No.",
  "SUPPLIER_EAN": "Supplier EAN",
  "PLANNED_SHIFT_WEAR": "Planned shift wear",
  "PLANNED_CHANGE_OF_SEASON": "Planned change of season",
  "PUNCTURE_DAMAGE": "Puncture / damage",
  "ON_CALL_ACUTE_INJURY": "On call / acute injury",
  "MISCELLANEOUS": "Miscellaneous",
  "PRICE_SEK": "Price (SEK)",
  "EXIT_WORKING_ORDER_POPUP": "Leave working order?",
  "EXIT_WORKING_ORDER_POPUP_DESCRIPTION": "Are you sure you want to leave the current working order?",
  "REG_NR_WORKING_ORDER": "Reg.no or other vehicle ID",
  "NO_TIRES_AVAILABLE": "No tires available",
  "STEER_AXLE_OPTION": "Steer",
  "DRIVE_AXLE_OPTION": "Drive",
  "RUN_AXLE_OPTION": "Run",
  "AXLE": "Axle",
  "ARTICLE_WORKING_ORDER": "Description of Product / Service",
  "DESCRIPTION_WORKING_ORDER": "Reason / justification for product outside the contract",
  "TOTAL_VALUE_WORKING_ORDER": "Total value of working order",
  "WORKING_ORDER_SUMMARY_INFO": "Click the previous button if you need to go back and make changes",
  "WORK_SUBMITTED_SUCCESSFULLY": "Work order submitted successfully!",
  "WORK_ORDER_GENERIC_ERROR": "Something went wrong, try again later.",
  "TIRE_POLICY_LIST": "Tire policy list",
  "IMPORT_TIRE_POLICIES": "Import tire policies",
  "WORK_ORDERS_LIST": "Work orders list",
  "CREATE_WORK_ORDER": "Create work order",
  "WORK_ORDER_STATE": "Work order state",
  "WORK_ORDER_ID": "Work order id",
  "WORK_ORDERS": "Work orders",
  "APROVE_WORK_ORDER": "Aprove work order",
  "DECLINE_WORK_ORDER": "Decline work order",
  "CANCEL_WORK_ORDER": "Cancel work order",
  "DELETE_PARTNER_AGREEMENT_SUCCESS": "Partner agreement deleted successfully",
  "DELETE_PARTNER_AGREEMENT_ERROR": "Error when deleting partner agreement",
  "ARCHIVE_AGREEMENT": "Archive agreement",
  "ARCHIVE_PARTNER_AGREEMENT_CONFIRM": "Are you sure you want to archive this partner agreement?",
  "ARCHIVE_PARTNER_AGREEMENT_SUCCESS": "Partner agreement archived successfully",
  "ARCHIVE_PARTNER_AGREEMENT_ERROR": "Error when archiving partner agreement",
  "RESTORE_AGREEMENT": "Restore agreement",
  "RESTORE_PARTNER_AGREEMENT_CONFIRM": "Are you sure you want to restore this partner agreement?",
  "RESTORE_PARTNER_AGREEMENT_SUCCESS": "Partner agreement restored successfully",
  "RESTORE_PARTNER_AGREEMENT_ERROR": "Error when restoring partner agreement",
  "WORKING_ORDER_COMMENT": "Comment",
  "WORKING_ORDER_DECISION": "Work order decision",
  "EDIT_WORK_ORDER": "Edit work order",
  "GROSS_PRICE_WORKING_ORDER": "Gross price",
  "CREDIT_BLOCKED_COLMEC": "You will not be able to place an order since your account has been credit blocked at Colmec. Please contact Colmec for more information and to resolve this issue.",
  "AVAILABILITY_EXCEEDED": "Quantity exceeds available stock"
}